export default Object.freeze({
    PERFORMER: 'PERFORMER',
    MODERATOR: 'MODERATOR',
})
